import React from "react";

import ChatListBubble from "./ChatListBubble";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";

interface unReadChatsProps {
  unReadChatsFilter: any[];
  setSelectedChatId: (id: string) => void;
  handleSelectChat: (id: string) => void;
  selectedChat: any;
  selectedChatId: string;
}

const UnReadChat: React.FC<unReadChatsProps> = ({
  handleSelectChat,
  selectedChatId,
}) => {
  const chatList = useSelector(
    (state: RootState) => state.whatsAppData.whatsappChatList
  )?.filter((chat) => chat.unReadMessage > 0);
  return (
    <div className="flex-1 overflow-y-auto">
      {chatList?.map((chat, index) => (
        <ChatListBubble
          index={index}
          key={chat._id}
          chat={chat}
          handleSelectChat={handleSelectChat}
          selectedChatId={selectedChatId}
        />
      ))}
    </div>
  );
};
export default UnReadChat;
